import Navbar from "./Navbar";
import "./Components.css";

export default function Header() {
  return (
    <header className="header">
        <Navbar />
    </header>
  );
}